import { round } from "services/helpers";

const FORWARD = 3;
const PUT = 3;
const SELLER = 3;

const toNumber = (value) => {
  const parsed = parseFloat(String(value ?? 0).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : 0;
};

// Result of an open derivative at the current spot price. Same payoff as the
// server's closed result (InvestimeServer options/payoff.py):
//   holder call / forward: S - K, holder put: K - S, an option never below zero
//   seller: the opposite of the holder payoff, plus the premium it received
//   costs always reduce the result
export const openDerivativeOutcome = (row, spotPrice) => {
  const quantity = toNumber(row?.quantity);
  const strike = toNumber(row?.strike_price);
  const spot = Math.abs(toNumber(spotPrice));
  const forward = Number(row?.derivative_type) === FORWARD;
  // role_for_outcome is the side the server calculates the result for: it can
  // differ from the stored role when the confirmation names the other side.
  const seller = Number(row?.role_for_outcome ?? row?.role) === SELLER;
  const premium = forward ? 0 : round(toNumber(row?.premium_total), 2);
  const costs = Math.abs(toNumber(row?.other_expenses));

  let perUnit = spot - strike;
  if (!forward && Number(row?.option_right) === PUT) perUnit = -perUnit;
  if (!forward) perUnit = Math.max(perUnit, 0);
  if (seller) perUnit = -perUnit;

  const premiumFlow = seller ? premium : -premium;
  return round(quantity * perUnit + premiumFlow - costs, 2) || 0;
};
